import { createFileRoute } from '@tanstack/react-router';
import { ConnectionsTab } from '@/features/integrations';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/all/overview')({
  component: withRumPageRendered(ConnectionsTab),
});
